/* src/app/workshop/partials/workshop-nav/workshop-nav.component.scss */
.workshop-toolbar {
  background: #EEEEEE;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
}
.workshop-nav {
  border: 2px solid black;
  border-radius: 10px;
  text-align: center;
  background: #fff;
}
.workshop-nav:hover {
  border: 2px solid red;
  cursor: pointer;
}
.workshop-nav-inactive {
  border: 2px solid #999999;
  border-radius: 10px;
  text-align: center;
  color: #999999;
  background: #ccccccc;
}
.workshop-nav-inactive:hover {
  cursor: not-allowed;
}
.onPage {
  border: 2px solid blue;
}
/*# sourceMappingURL=workshop-nav.component.css.map */
